
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";

const CardWrapper = styled.div`
    @media only screen and (max-device-width: 480px) {
        margin: 0px;
    }
`;


const CardInner = styled.div`
    padding: 26px 36px;
    color: white;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

`;

const Title = styled.div`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 130.5%;
    /* identical to box height, or 29px */

    display: flex;
    align-items: center;
    text-align: center;
    text-transform: uppercase;

    color: #FFFFFF;
`;

const Subtitle = styled.div`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 145%;
    /* or 20px */

    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    opacity: 0.4;
    margin-top: 20px;
`;

const Button = styled.div`
    background: rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    color: #fff;
    padding: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 34px;
    width: 100%;
`;


/* 
    1 props
    1. id of the perk to fetch data for   
*/
export default function PerkTutorail({perkId}) {
    const [perkData, setPerkData] = useState();   

    //TODO: get perk data from the api or get it from the props
    // useEffect(() => {
    //     if(perksData.length > 0) setPerks(perksData);
    // }, [perksData]);

    const Card = ({perkData}) => {
        return (
            <CardWrapper onClick={() => {              
                }}
                style={{
                    borderColor: 'transparent'
                }}>
                <video 
                    src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/blackbox.mp4.mp4'} 
                    style={{width: '100%', height: 250}}
                />
                <CardInner className={`perk-tutorial perk-tutorial-${perkId}`}>
                    <Title>Throw flashbang on screen</Title>  
                    <Subtitle>Throw a grenade on stream & blind all viewers for 6 seconds</Subtitle>
                    <Button>GOT IT, COOL</Button>                    
                </CardInner>                
            </CardWrapper>
        );
    }


    return (
        <>
            <Card perkData={perkData} />
        </>
    )
}
